import React, { createContext, useContext, ReactNode } from 'react';
import { Locale } from 'src/productData';

// Locale type definition

// PageContext type definition
export interface PageContextType {
  productId: string;
  locale: Locale;
  unlocalizedPath: string;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

// Custom hook to use the PageContext
export const usePageContext = (): PageContextType => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext must be used within a PageContextProvider');
  }
  return context;
};

// Context Provider component
interface PageContextProviderProps {
  children: ReactNode;
  value: PageContextType;
}

export const PageContextProvider: React.FC<PageContextProviderProps> = ({
  children,
  value,
}) => {
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};
